import { AnimatePresence, motion } from "framer-motion";
import { useCallback, useEffect, useMemo, useRef } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Colors } from 'chart.js';
import { useDispatch, useSelector } from "react-redux";
import { getVotaciones } from "../../slices/votacionesSlice";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Colors);

export default function EstadisticaVotaciones() {

  const chartRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const chart = chartRef.current;
      if (chart) {
        chart.resize();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const dispatch = useDispatch()

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {}, []);

  const { votaciones } = useSelector(state => state.votaciones)

  const conteoVotos = useMemo(() => 
    votaciones.reduce((acc, { vote }) => {
      acc[vote] = (acc[vote] || 0) + 1;
      return acc;
    }, { 1: 0, 2: 0, 3: 0, 4: 0 })
  , [votaciones]);

  useEffect(() => {
    dispatch(getVotaciones())
  },[dispatch])

  const data = {
    labels: ['Tips para cotizar un software', 'Como no cagarla emprendiendo en tecnología', 'La tecnología presente futuro', 'Hackeo: Mitos y verdades'],
    url:["https://www.beautiful.ai/player/-OJzTKJnIBomxfHy0rF7", "https://www.beautiful.ai/player/-OJzTUyjWxd4zOYIYYO4", "https://www.beautiful.ai/player/-OJzTcBQ6LVyemHZQKV6", "https://www.beautiful.ai/player/-OJzTjR5NHCD0vKTcta8"],
    datasets: [
      {
        label: 'Votaciones',
        data: [conteoVotos[1], conteoVotos[2], conteoVotos[3], conteoVotos[4]],
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
        color: 'white'
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Esto permite que el gráfico no mantenga un aspect ratio fijo
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: window.innerWidth < 768 ? 14 : 14, // Tamaño de fuente responsive
          },
          color: 'white',
        },
      },
      title: {
        display: true,
        text: 'Votaciones',
        font: {
          size: window.innerWidth < 768 ? 20 : 24, // Tamaño de fuente responsive
        },
        color: 'white',
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: window.innerWidth < 768 ? 10 : 14, // Tamaño de fuente responsive
          },
          color: 'white',
        },
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          font: {
            size: window.innerWidth < 768 ? 10 : 14, // Tamaño de fuente responsive
          },
          color: 'white',
        },
        grid: {
          display: true,
          color: 'rgba(255, 255, 255, 0.1)',
        },
      },
    },
  };
  // Calcula el índice de la opción con más votos
  const maxVotesIndex = Object.values(conteoVotos).indexOf(Math.max(...Object.values(conteoVotos)));

  // URL de la opción con más votos
  const urlMaxVotes = data.url[maxVotesIndex];


  return (
    <div className="w-full h-screen" style={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
      }} >

         <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{
                  background: { color: "#000" },
                  fpsLimit: 120,
                  particles: {
                    number: { value: 150 },
                    color: { value: ["#FF0000", "#FF7F00"] },
                    shape: {
                      type: "circle",
                    },
                    move: {
                      enable: true,
                      speed: 2,
                      direction: "none",
                      outMode: "bounce",
                      random: true,
                      straight: false,
                    },
                    size: {
                      value: { min: 1, max: 3 },
                    },
                    opacity: {
                      value: { min: 0.1, max: 0.5 },
                    },
                  },
                  interactivity: {
                    events: {
                      onHover: { enable: true, mode: "repulse" },
                      onClick: { enable: true, mode: "push" },
                    },
                  },
                }}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100vh",
                  zIndex: -1,
                }}
              />
              <AnimatePresence>
                <motion.div className="flex flex-wrap z-10 relative" >
                  
                    <div className="w-full h-screen flex justify-center items-center p-4"> {/* Añadido padding para móviles */}

                      <div className="w-full h-full md:w-4/5 md:h-4/5"> {/* Ajuste del tamaño del contenedor */}
                        <Bar ref={chartRef} data={data} options={options}  />
                      </div>
                    
                    </div>
                      {/* Botón que redirige a la URL de la opción con más votos */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
            <a href={urlMaxVotes} target="_blank" rel="noopener noreferrer">
              <button className="bg-blue-500 text-white px-4 py-2 rounded-full">
                Ver opción más votada
              </button>
            </a>
          </div>
                </motion.div>
              </AnimatePresence>

    </div>
  )
}